import AbstractRuleModel from "../AbstractRuleModel.js";

/**
 * Abstract class of a prediction model. Each class is a strategy to compute
 * predicted data for a forecast.
 *
 * @param {string} [description] - The text that explains the reason around the rule
 * @abstract
 */
export default class AbstractPredictionRuleModel extends AbstractRuleModel {
	constructor({ description = "" } = {}) {
		super(...arguments);

		this._description = description;
	}

	getDescription() {
		return this._description;
	}

	setDescription(description) {
		this._description = description;
	}

	getLabel() {
		return this.constructor.getLabel();
	}

	isPrediction() {
		return true;
	}

	accept(visitor) {
		return visitor.visitAbstractPredictionRuleModel(this);
	}

	getKind() {
		return AbstractPredictionRuleModel;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.description = this._description;

		return properties;
	}
}
